var $ = jQuery;

function toggleAccordion(header, menu, icon) {
    menu.slideToggle();
    icon.toggleClass("fa-chevron-up");
}

$(document).ready(function() {
    var windowWidth = $(window).width();
    var headers = $(".footer .grid__item .grid__item__header");
    var footerMenus = $(".footer .grid__item .footer-menu");
    var icons = headers.find("i");

    function setupAccordion() {
        if (windowWidth < 770) {
            headers.click(function(e) {
                e.preventDefault();
                var index = headers.index(this);
                var menu = footerMenus.eq(index);
                var icon = icons.eq(index);
                toggleAccordion($(this), menu, icon);
            });
            footerMenus.hide();
        } else {
            footerMenus.show();
            icons.removeClass("fa-chevron-up");
            headers.unbind("click");
        }
    }

    setupAccordion();

    $(window).resize(function() {
        windowWidth = $(window).width();
        setupAccordion();
    });

});
